module.exports = __webpack_public_path__ + "static/media/planet-logo.f3fef27d.png";